const newLetterConstantsAr = {
  thumbnail: 'رابط الصورة المصغرة',
  publishSwitch: 'منشور',
  minutesOfReading: 'الوقت اللازم للقراءة',
  newARTags: 'الوسوم بالعربية',
  newENTags: 'الوسوم بالإنجليزية',
  thumbnailValidation: 'الرجاء إدخال رابط الصورة المصغرة',
  editNew: 'تعديل الخبر',
  createNew: 'إضافة خبر',
};

export default newLetterConstantsAr;
